module.exports = __webpack_public_path__ + "static/img/en.260e9384.svg";